import { styled } from 'styled-components';
import { textMediumSemiBold, textSmallSemiBold, textTinySemiBold } from '../../Typography';

export const Container = styled.button`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  border-radius: var(--radius-400);
  height: fit-content;
  cursor: pointer;
  gap: var(--space-100);
  transition: all 0.2s ease-out;
  --iconOffset: 2px;

  svg.prefixIcon {
    position: relative;
    left: calc( -1 * var(--iconOffset));
  }

  svg.suffixIcon {
    position: relative;
    left: var(--iconOffset);
  }

  &.tiny {
    ${textTinySemiBold};
    padding: var(--space-75) var(--space-100);
    gap: var(--space-250);
    min-height: 28px;
    --iconOffset: 3px;
  }

  &.small {
    ${textSmallSemiBold};
    padding: var(--space-75) var(--space-150);
    gap: var(--space-50);
    min-height: 32px;
    --iconOffset: 4px;
  }

  &.medium {
    ${textMediumSemiBold};
    padding: var(--space-100) var(--space-200);
    min-height: 36px;
    gap: var(--space-75);
    --iconOffset: 5px;
  }

  &:disabled {
    cursor: not-allowed;
  }

  &.default {
    border: 1px solid var(--border-color-secondary);
    background: var(--button-background);
    color: var(--text-standard-primary);

    svg path {
      color: var(--text-standard-primary);
    }

    &:hover {
      background-color: var(--black-500);
    }

    &:active {
      background-color: var(--black-400);
    }

    &:focus-visible:not(:disabled):not(:active) {
      color: var(--turquoise-400);
      border-color: var(--turquoise-400);
      outline: none;
      svg path {
        color: var(--turquoise-400);
      }
    }

    &:disabled {
      background-color: var(--black-200);
      color: var(--black-600);
    }
  }

  &.brand {
    background-color: var(--turquoise-400);
    color: var(--text-standard-primary-subtle);
    border: 1px solid var(--turquoise-400);

    svg path {
      color: var(--text-standard-primary-subtle);
    }

    &:hover {
      background-color: var(--turquoise-500);
    }

    &:active {
    }

    &:focus-visible:not(:disabled):not(:active) {
      background-color: var(--white);
      border: 1px solid var(--turquoise-400);
      color: var(--turquoise-400);
      outline: none;
      svg path {
        color: var(--turquoise-400);
      }
    }

    &:disabled {
      color: var(--turquoise-200);
      svg path {
        color: var(--turquoise-200);
      }
    }
  }

  &.positive {
    background: var(--button-background);
    color: var(--green-200);
    border: 1px solid var(--green-200);
    svg path {
      color: var(--green-200);
    }

    &:hover:not(:disabled) {
      background-color: var(--green-200);
      color: var(--text-standard-primary-subtle);
      svg path {
        color: var(--text-standard-primary-subtle);
      }
    }

    &:active:not(:disabled) {
      border-color: var(--green-200);
      background-color: var(--green-150);
      color: var(--text-standard-primary-subtle);
      svg path {
        color: var(--text-standard-primary-subtle);
      }
    }
  }

  &.destructive {
    background: var(--button-background);
    color: var(--red-200);
    border: 1px solid var(--red-200);
    svg path {
      color: var(--red-200);
    }

    &:hover:not(:disabled) {
      background-color: var(--red-200);
      color: var(--text-standard-primary-subtle);
      svg path {
        color: var(--text-standard-primary-subtle);
      }
    }

    &:active:not(:disabled) {
      border-color: var(--red-200);
      background-color: var(--red-150);
      color: var(--text-standard-primary-subtle);
      svg path {
        color: var(--text-standard-primary-subtle);
      }
    }
  }

  &.warning {
    background: var(--button-background);
    color: var(--orange-200);
    border: 1px solid var(--orange-200);
    svg path {
      color: var(--orange-200);
    }

    &:hover:not(:disabled) {
      background-color: var(--orange-200);
      color: var(--text-standard-primary-subtle);
      svg path {
        color: var(--text-standard-primary-subtle);
      }
    }

    &:active:not(:disabled) {
      border-color: var(--orange-200);
      background-color: var(--orange-150);
      color: var(--text-standard-primary-subtle);
      svg path {
        color: var(--text-standard-primary-subtle);
      }
    }
  }

  &.upsell {
    position: relative;
    color: var(--pink-200);
    border: 0px solid transparent;
    background: linear-gradient(142deg, var(--button-background));

    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      width: calc(100% + 2px);
      height: calc(100% + 2px);
      background: linear-gradient(90deg, #f9c5d1, #a18cd1);
      pointer-events: none;
      z-index: -1;
      border-radius: var(--radius-400);
    }

    &:hover:not(:disabled) {
      background: linear-gradient(142deg, #FFF -8.43%, #F9BAF9 27.33%, #9470FD 91.21%);
      color: var(--text-standard-primary-subtle);
    }

    &:active:not(:disabled) {
      background: linear-gradient(142deg, #9470FD -8.43%, #F9BAF9 55.45%, #FFF 91.21%);
      color: var(--text-standard-primary-subtle);
    }
  }
`;
